import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import getWin32StyleEnabled from './getWin32StyleEnabled';

/**
 * Determines if Win32 styling UI changes should be applied.
 *
 * Returns true only when BOTH conditions are met:
 * 1. The 'mon-win32-styling' feature flight is enabled (controls server-side rollout)
 * 2. The user has enabled the Win32 style setting (controls user choice)
 *
 * @returns true if Win32 styling is both flighted and enabled by the user
 */
export default function isWin32StylingEnabled(): boolean {
    return isGlobalFeatureEnabled('mon-win32-styling') && getWin32StyleEnabled();
}
